import { render, staticRenderFns } from "./BusMessages.vue?vue&type=template&id=7ed93359&scoped=true&"
import script from "./BusMessages.vue?vue&type=script&lang=js&"
export * from "./BusMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed93359",
  null
  
)

export default component.exports